import { render, staticRenderFns } from "./DailyChallengeXPHeader.vue?vue&type=template&id=4c69d0d4&scoped=true&"
import script from "./DailyChallengeXPHeader.vue?vue&type=script&lang=ts&"
export * from "./DailyChallengeXPHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallengeXPHeader.vue?vue&type=style&index=0&id=4c69d0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c69d0d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c69d0d4', component.options)
    } else {
      api.reload('4c69d0d4', component.options)
    }
    module.hot.accept("./DailyChallengeXPHeader.vue?vue&type=template&id=4c69d0d4&scoped=true&", function () {
      api.rerender('4c69d0d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DailyChallengeXPHeader.vue"
export default component.exports